import React, { FC } from 'react';
import { Box, Text, Icon, IconSize, theme, DateField } from '@bechtel/gds';
import { format } from 'date-fns';
import { DateHeaderProps } from './types';

export const DateHeader: FC<DateHeaderProps> = ({ selectedDate, onDateSelect, disable = false }) => {
  return (
    <Box
      css={`
        background-color: ${theme.colors.white};
        flex: 1;
      `}
    >
      <DateField
        maxDate={new Date()}
        selected={selectedDate}
        onChange={(selectedDate) => {
          if (onDateSelect) {
            onDateSelect(selectedDate);
          }
        }}
        customInput={
          <Box
            px={{ sm: '600' }}
            pt={{ sm: '450' }}
            pb={{ sm: '400' }}
            gap={{ sm: '600' }}
            alignItems={{ sm: 'center' }}
            style={disable ? { pointerEvents: 'none', cursor: 'none' } : { cursor: 'pointer' }}
          >
            <Text family="graphik" weight="600" color="grey.1000" size="600">
              {format(selectedDate, 'EEEE, LLL d')}
            </Text>
            <Icon size={IconSize.LARGE} icon="calendar-day" fillColor="bechtel.blue.800" />
          </Box>
        }
        showPopperArrow={false}
      />
    </Box>
  );
};
